import { render, staticRenderFns } from "./SortForm.vue?vue&type=template&id=c499be4c&scoped=true"
import script from "./SortForm.vue?vue&type=script&lang=js"
export * from "./SortForm.vue?vue&type=script&lang=js"
import style0 from "./SortForm.vue?vue&type=style&index=0&id=c499be4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c499be4c",
  null
  
)

export default component.exports